import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import ObrasSociales from "@/components/landing/ObrasSociales";
import Patologias from "@/components/landing/Patologias";
import Equipo from "@/components/landing/Equipo";
import Ubicacion from "@/components/landing/Ubicacion";
import Footer from "@/components/landing/Footer";
import FloatingWhatsapp from "@/components/landing/FloatingWhatsapp";

export default function Landing() {
  return (
    <div className="min-h-screen bg-cream text-navy-900 selection:bg-turquoise-200 selection:text-navy-900">
      <Header />
      <main data-testid="landing-main">
        <Hero />
        <ObrasSociales />
        <Patologias />
        <Equipo />
        <Ubicacion />
      </main>
      <Footer />
      <FloatingWhatsapp />
    </div>
  );
}
